import * as React from 'react';
import Icon, { IconType } from './icon';

export interface ButtonProps {
    onClick?: (e?: any) => void;
    style?: React.CSSProperties;
    className?: string;
    leftIcon?: IconType;
    rightIcon?: IconType;
    icon?: IconType;
    disabled?: boolean;
    presentation?: 'dark' | 'light' | 'wire' | 'blueprint' | 'fingerprint' | 'black';
    onRef?: (node: any) => void;
    as?: any;
    extraProps?: any;
}

export interface ButtonState {
}

export default class Button extends React.Component<ButtonProps, ButtonState> {
  constructor(props: ButtonProps) {
    super(props);

    this.state = {
    }
  }

  public render() {

    const class_ = (`button ${this.props.presentation || ' light'} ${this.props.disabled? ' disabled': ''} ${this.props.className || '' }`);
    
    const common = {
      ref: (node) => {if(this.props.onRef)this.props.onRef},
      className: class_,
      onClick: (e?: any) =>
      {
        if(this.props.onClick && !this.props.disabled)
          this.props.onClick(e)
      },
      style: this.props.style,
      ...this.props.extraProps
    };

    const as = this.props.as || <a/>;

      const {type: Component} = as;

      return (
        <Component {...common}>
          {this.props.leftIcon && <Icon className={`${this.props.presentation !== 'wire'? 'btn-icon left' : ''}`} type={this.props.leftIcon} />}
          {this.props.children}
          {this.props.icon && <Icon className={`btn0icon`} type={this.props.icon} />}
          {this.props.rightIcon && <Icon className={`${this.props.presentation !== 'wire'? 'btn-icon right' : ''}`} type={this.props.rightIcon} />}
        </Component>
        );
    
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/button.tsx